import { Icon } from "@iconify/react";
import ButtonPrimary from "./ButtonPrimary";

interface HeroProps {
  title?: string;
  highlight?: string;
  subtitle?: string;
  ctaLabel?: string;
  ctaHref?: string;
  imageSrc?: string;
  imageAlt?: string;
  tinaFields?: Partial<
    Record<"title" | "highlight" | "subtitle" | "ctaLabel" | "ctaHref" | "imageSrc" | "imageAlt", string>
  >;
}

export const Hero = ({
  title = "Feel Better, Move Freely.",
  highlight = "KMA Massage",
  subtitle = "Experience natural healing through expert massage and joint adjustment.",
  ctaLabel = "Learn More",
  ctaHref = "/massage-services",
  imageSrc = "/uploads/massage_image2.png",
  imageAlt = "KMA Massage",
  tinaFields,
}: HeroProps) => {
  return (
    <div className=" relative h-[700px] sm:h-[800px] md:h-[900px] lg:h-[550px] xl:h-[600px] bg-white dark:bg-dark-hero-ui overflow-hidden">
      <div className="hero-img-bg absolute top-0 left-0 md:left-1/3 z-1 w-full  h-[700px] sm:h-[800px] md:h-[900px] lg:h-[550px] xl:h-[600px] bg-[url(/bg-gradient.jpg)] dark:bg-none  bg-no-repeat bg-[center_top] "></div>
      <div className="hero-dot-bg absolute top-0 left-0 z-2 w-[100%] h-full overflow-hidden  mt-0">
        <svg className="dot_background absolute w-full h-full top-0 left-0 fill-bg-gray-800 dark:fill-light">
          <pattern
            id="pattern-hero"
            x="14"
            y="3"
            width="20"
            height="20"
            patternUnits="userSpaceOnUse"
            patternTransform="translate(-11,-11)"
          >
            <circle cx="0.5" cy="0.5" r="0.5" className="dot_background-pattern dots"></circle>
          </pattern>
          <rect x="0" y="0" width="100%" height="100%" fill="url(#pattern-hero)"></rect>
        </svg>
      </div>
      <div className="absolute  w-full h-full left-0 top-0 z-10">
        <div className="flex flex-col lg:flex-row justify-center align-center items-center w-[100%] h-full">
          <div
            className="mt-10 text-center text-primary-darker-text dark:text-white mx-auto lg:mx-0 lg:text-left max-w-lg relative bg-white/10 dark:bg-dark-purple-ui/10 backdrop-blur-[2px] p-5 px-3 lg:px-[35px]"
            //   style="pointer-events: all;"
          >
            <h1
              className="tracking-[-0.02rem] text-4xl lg:text-6xl mb-4 font-semibold font-poppins"
              data-tina-field={tinaFields?.title}
            >
              {title}{" "}
              {highlight && (
                <span className="text-primary dark:text-primary-lighter" data-tina-field={tinaFields?.highlight}>
                  {highlight}
                </span>
              )}
            </h1>
            <h2 className="mb-4 lg:mb-6 text-xl italic" data-tina-field={tinaFields?.subtitle}>
              {subtitle}
            </h2>
            <div className="flex justify-center lg:justify-start">
              <div className="flex">
                <ButtonPrimary
                  url={ctaHref}
                  label={ctaLabel}
                  icon={<Icon icon="tabler:massage" className="text-2xl mr-1" />}
                  size="md"
                  dataTinaField={tinaFields?.ctaHref}
                  labelDataTinaField={tinaFields?.ctaLabel}
                />
              </div>
            </div>
          </div>
          <div
            className="w-full h-full max-w-3xl p-8 flex justify-center items-center"
            data-tina-field={tinaFields?.imageAlt}
          >
            <img
              src={imageSrc}
              alt={imageAlt}
              data-tina-field={tinaFields?.imageSrc}
              className="w-full object-cover rounded-4xl saturate-120 brightness-100 contrast-125"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Hero;
